// ----------------------------------------------------------------------------
// IMPORTS
// ----------------------------------------------------------------------------
import React from "react";
import ReactDOM from "react-dom/client";
import "./theme/tokens.css";
import "./index.css";
import { brandColors } from "./theme/colors";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter, useLocation } from "react-router-dom";
import AllRoutes from "./Components/Routes";
import Store from "./Store/Store";
import { Toaster } from "react-hot-toast";
import { useEffect } from "react";
import { mixpanelEvent } from "./Utils/mixpanelUtils";
import { GlobalProvider } from "./Context/GlobalContext";
import { refreshSession, shouldRefreshSession } from "./Services/AuthService";

// ----------------------------------------------------------------------------

const App = () => {
  const location = useLocation();

  useEffect(() => {
    mixpanelEvent("screen_loaded", {
      load_time: performance.now(),
      url: location.pathname,
      page_title: document.title,
      screen_name: location.pathname.split("/").pop() || "home",
    });
  }, [location]);

  return (
    <GlobalProvider>
      <AllRoutes />
    </GlobalProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
const renderApp = () => root.render(
  <Store>
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        gutter={12}
        containerStyle={{ margin: "8px" }}
        toastOptions={{
          success: {
            duration: 5000,
            style: {
              backgroundColor: brandColors.primary,
              color: brandColors.onPrimary,
            },
            iconTheme: {
              primary: brandColors.onPrimary,
              secondary: brandColors.primary,
            },
          },
          error: {
            duration: 5000,
            style: {
              backgroundColor: "#d32f2f",
              color: "#fff",
            },
            iconTheme: {
              secondary: "#d32f2f",
              primary: "#FFFAFA",
            },
          },
          style: {
            fontSize: "14px",
            padding: "12px 16px",
            borderRadius: "10px",
            backgroundColor: brandColors.primary,
            color: brandColors.onPrimary,
            maxWidth: "400px",
          },
        }}
      />
    </React.StrictMode>
  </Store>
);

// The route guards check the token synchronously, so swap an expired or expiring token
// before the first render instead of logging out a user whose refresh token is still valid.
if (shouldRefreshSession()) {
  refreshSession().finally(renderApp);
} else {
  renderApp();
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
